import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { useGetAdditionalEntityDetailsStore } from '../../Stores/useGetAdditionalEntityDetailsStore'

export const usePolicyHolderHydration = () => {
  const { setPolicyholderDetails, setPolicyholderDetailsSelected } =
    usePolicyholderDetailsStore()
  const { setPolicyholderAdditionalDetails } =
    useGetAdditionalEntityDetailsStore()

  const handlePolicyholderDetailsHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    setPolicyholderDetails({}) //TODO: Check if this data will come, on proposal only 1 entity is selected
  }

  const handlePolicyholderDetailsSelectedHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const policyHolder = data.entities?.policyHolder

    setPolicyholderDetailsSelected({
      idEntity: policyHolder?.idEntity,
      name: policyHolder?.name,
      addresses: policyHolder?.addresses?.map((item) => ({
        addressType: item.addressType,
        addressTypeDescription: item.addressTypeDescription,
        countryCode: item.countryCode,
        countryDescription: item.countryDescription,
        districtCode: item.districtCode,
        formatType: item.formatType,
        countyCode: item.countyCode,
        georeference: item.georeference,
        isFiscalAddress: item.isFiscalAddress || false, //TODO: Review
        isReturnedForCorrection: item.isReturnedForCorrection || false, //TODO: Review
        locationId: item.sequence,
        postalCode: item.postalCode,
        postalCodeDescription: item.postalCodeDescription,
        typology: item.tipology,
      })),
      birthdate: policyHolder?.birthdate || '',
      entityType: policyHolder?.entityType,
      vatNumber: policyHolder?.vatNumber,
      idNetwork: '', //TODO: Review, do not have this in Resume
    })
  }

  const handlePolicyholderAdditionalDetails = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const policyHolder = data.entities?.policyHolder

    setPolicyholderAdditionalDetails({
      cae: policyHolder?.caes?.[0]?.cae,
      emailContact: {
        email: policyHolder?.contactDetails?.emailContactList?.[0]?.eMail,
        emailContactID:
          policyHolder?.contactDetails?.emailContactList?.[0]?.eMailContactId,
        emailTypeCode:
          policyHolder?.contactDetails?.emailContactList?.[0]?.eMailTypeCode,
        emailTypeDescription:
          policyHolder?.contactDetails?.emailContactList?.[0]
            ?.eMailTypeDescription,
        preferentialEmailContact:
          policyHolder?.contactDetails?.emailContactList?.[0]
            ?.preferentialEMailContact,
      },
      gender: policyHolder?.gender,
      nationality: policyHolder?.nationality,
      phoneContactList: policyHolder?.contactDetails?.phoneContactList?.map(
        (item) => ({
          phoneNumber: String(item.phoneContactNumber || 0),
        }),
      ),
      professionList: policyHolder?.professionList?.map((item) => ({
        professionCode: item.professionalCode,
        professionDescription: item.professionalDescription,
      })),
    })
  }

  return {
    handlePolicyholderDetailsHydration,
    handlePolicyholderDetailsSelectedHydration,
    handlePolicyholderAdditionalDetails,
  }
}
